import React, { useContext, useMemo } from 'react';

import { Box } from '@material-ui/core';
import { Redirect, Route, Switch } from 'react-router-dom';

import { DeviceContext } from '@vyce/core/src/contexts';
import { CommonNavBarBlock } from '@vyce/core/src/components';
import { getPaddingForContent } from '@vyce/core/src/utils';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';

import { USER_MANAGEMENT_TABS } from './constants';
import { EmployerStaffManagement, EmployerInviteList, Users } from './components';

export const EmployerUserManagement: React.FC = () => {
  const { isMobile } = useContext(DeviceContext);
  const padding = getPaddingForContent(isMobile);
  const { filterTabs } = usePermissions();
  const tabs = useMemo(() => filterTabs(USER_MANAGEMENT_TABS), [filterTabs]);

  return (
    <>
      <CommonNavBarBlock tabItems={tabs} />

      <Box padding={padding}>
        <Switch>
          <Redirect exact from="/user-management" to="/user-management/users" />
          <Redirect exact from="/user-management/payroll" to="/user-management/users?domain=payroll" />
          <Redirect exact from="/user-management/teams" to="/user-management/users?domain=teams" />
          <Redirect exact from="/user-management/time" to="/user-management/users?domain=time" />
          <Route path={'/user-management/users'} component={Users} />
          <Route path={'/user-management/admins'} component={EmployerStaffManagement} />
          <Route path={'/user-management/company-invites'} component={EmployerInviteList} />
        </Switch>
      </Box>
    </>
  );
};
